import { useQuery } from '@tanstack/react-query';

import { Category, CategoryQuery } from '../../../../types';
import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { unwrapNonPaginatedResponseDataAs } from '../../../logic/unwrapNonPaginatedResponseDataAs';
import { CATEGORIES_BASE_PATH } from '../../constants/categoriesBasePath';
import { selectCategories } from '../../requests/selectCategories';

export const useSelectCategories = (
  query: CategoryQuery,
  onSuccess?: (categories: Category[]) => void,
) => {
  const { constructPost } = useRequestConstructor();

  const { data, refetch, ...rest } = useQuery<
    Awaited<ReturnType<typeof selectCategories>>
  >({
    queryKey: [CATEGORIES_BASE_PATH, 'select', query],
    queryFn: () =>
      selectCategories(constructPost, query, {
        params: { include: 'childCategories' },
      }),
    onSuccess: (result) => onSuccess?.(result?.data ?? []),
    refetchOnWindowFocus: false,
  });

  return {
    ...unwrapNonPaginatedResponseDataAs(data, refetch, 'categories'),
    ...rest,
  };
};
